module.exports = __webpack_public_path__ + "media/images/flags/64/Samoa-33ef8d9509e89f6053ef7a712c38367b.png";